<template>
  <van-field
    v-model="val"
    :label="label"
    :placeholder="placeholder || label"
    :rows="rows" :maxlength="maxlength"
    :autosize="autosize" :show-word-limit="showWordLimit"
    :required="required"
    :rules="[{ required: required, message: '请输入' + label }]"
    :readonly="readonly"
    :clearable="clearable"
    type="textarea"
    @input="change"
  />
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    maxlength: {
      type: Number,
      default: 100
    },
    autosize: {
      type: Boolean,
      default: true
    },
    showWordLimit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  watch: {
    value: function(value) {
      this.val = value
    }
  },
  methods: {
    change(value) {
      this.$emit('change', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseTextarea.vue